import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SimpleSplitText } from '../../../utils/SimpleSplitText';

gsap.registerPlugin(ScrollTrigger);

export const useHome = () => {
  const location = useLocation();
  const container = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    try {
      const mm = gsap.matchMedia();
      mm.add("(min-width: 900px)", () => {
        const splits: SimpleSplitText[] = [];


        ScrollTrigger.refresh();

        return () => {
          splits.forEach(split => split.revert());
        };
      });
    } catch { }
  }, { scope: container });

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.substring(1);

      const scrollToSection = () => {
        const element = document.getElementById(elementId);
        if (element) {
          const header = document.querySelector('header');
          const headerHeight = header ? (header as HTMLElement).offsetHeight : 0;
          const top = element.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      };

      const timer = setTimeout(scrollToSection, 400);
      return () => clearTimeout(timer);
    }
  }, [location]);

  useEffect(() => {
    const timer = setTimeout(() => ScrollTrigger.refresh(), 300);

    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener('load', onLoad);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', onLoad);
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return { container };
};
